import api from "../services/index";

const notificationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationCount: builder.query({
      query: () => ({
        url: "/api/notification/getcount",
        method: "GET",
      }),
      providesTags: ["NotificationCount"],
    }),
    getNotifications: builder.query({
      query: () => ({
        url: "/api/notification/getAll",
        method: "GET",
      }),
      providesTags: ["Notification"],
    }),
    createNotification: builder.mutation({
      query: (body) => ({
        url: "/api/notification/create",
        method: "POST",
        body: body,
      }),
      invalidatesTags: [
        "Notification",
        "NotificationCount",
        "LatestNotification",
      ],
    }),
    getEmployeesList: builder.query({
      query: () => "/api/employee/getEmployeesList",
    }),
    getLatestNotifications: builder.query({
      query: () => "/api/notification/getlatest",
    }),
    providesTags: ["LatestNotification"],
  }),
});

export default notificationApi;
export const {
  useGetNotificationCountQuery,
  useGetNotificationsQuery,
  useCreateNotificationMutation,
  useGetEmployeesListQuery,
  useGetLatestNotificationsQuery,
} = notificationApi;
